import {FC, ReactElement, MouseEvent, useCallback, useMemo} from "react";
import {useFeedback} from "@memaro/feedback";
import Help from "@mui/icons-material/Help";
import IconButton, {IconButtonProps} from "@mui/material/IconButton";

type HelpButtonProps = {
    variant?: "inline" | "button"
    help: string | ReactElement
    absolutePosition?: boolean
    offsetTop?: number
    offsetRight?: number
}

const HelpButton: FC<HelpButtonProps> = ({help, variant = "inline", absolutePosition, offsetTop = 5, offsetRight = 2}) => {
    const {info} = useFeedback()
    const handleClick = useCallback((e: MouseEvent) => {
        e.preventDefault()
        e.stopPropagation()
        info?.(help)
    }, [info, help])

    const variantProps: Pick<IconButtonProps, "size" | "sx"> = useMemo(() => variant == "inline" ? {
        size: "small",
        sx: {marginLeft: "2px", marginTop: "-3px"}
    } : {
        size: "medium",
    }, [variant])

    const absolutePositionProps: Pick<IconButtonProps, "sx"> = useMemo(() => absolutePosition ? {
        sx: {
            position: "absolute",
            top: `${offsetTop}px`,
            right: `${offsetRight}px`,
        }
    } : {}, [absolutePosition, offsetRight, offsetTop])

    const buttonProps: Pick<IconButtonProps, "size" | "sx"> = useMemo(() => ({
        ...variantProps,
        sx: {
            ...(variantProps.sx ?? {}),
            ...(absolutePositionProps.sx ?? {})
        }
    }), [variantProps, absolutePositionProps])

    return (
        <IconButton aria-label="info" color="info" {...buttonProps} onClick={handleClick}>
            <Help fontSize="inherit" />
        </IconButton>
    )
}

export default HelpButton
